<template>
  <div class="onboarding-signup-step-cropper" view="hHh lPr fFf">
    <QHeader class="bg-black text-white">
      <QToolbar>
        <QToolbarTitle>
          {{ $t("ETAB.PAGES.SIGNUP.STEPS.INFO.CROPPER.@TITLE") }}
        </QToolbarTitle>
      </QToolbar>
    </QHeader>

    <QPageContainer>
      <Cropper :photo="img" @on-submit="savePhoto" @on-close="cancel" />
    </QPageContainer>
  </div>
</template>
<script>
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { EtabProfileService } from "@core/services";
  import { signupMixin } from "@etab/mixins";
  import Cropper from "@etab/components/common/Cropper.component.vue";
  import { ETAB_ROUTES } from "@etab/config";

  export default {
    components: {
      Cropper,
    },
    mixins: [signupMixin],
    computed: {
      img: {
        get() {
          return this.$_signupModel[this.$ISignup.img];
        },
      },
    },
    methods: {
      cancel() {
        this.$router.go(-1);
      },
      async savePhoto(photo) {
        try {
          this.$_startGlobalLoading();
          await EtabProfileService.savePhoto({ photo });
          // replace in order to not come back to the cropper page
          this.$router.replace({ name: ETAB_ROUTES.signup.steps.success.name, query: { update: true } });
        } catch (error) {
          // we stop loading in the next page so no finally is needed here
          this.$_stopGlobalLoading();
          NotificationsManager.error({ message: "ERRORS.@SOMETHING_WENT_WRONG" });
          throw error;
        }
      },
    },
  };
</script>

<style lang="scss">
  .onboarding-signup-step-cropper {
    background: black;
  }
</style>
